class MiniCartToggle extends HTMLElement {
  constructor() {
    super()

    const isCartPage = document.body.classList.contains('template-cart')

    this.cartIcon = document.getElementById('cart-icon-bubble')
    this.miniCart = document.getElementById('mini-cart')
    this.cartOverlay = document.querySelector('[data-cart-overlay]');
    this.cartBackdrop = document.querySelector('[data-cart-backdrop]');

    this.closeCartIcon = this.querySelector('.js-cart-close')

    if(!checkIfEventOnCartIcon){
      checkIfEventOnCartIcon = true;
      this.cartIcon.addEventListener('click', (evt) => {
        evt.preventDefault()
        if (!isCartPage) {
          this.open()
        }
      })
    }

    if (!isCartPage) {
      this.onBodyClick = this.handleBodyClick.bind(this)
    }

    if (this.closeCartIcon) {
      this.closeCartIcon.addEventListener('click', () => {
        this.close()
      })
    }

    this.cartBackdrop.addEventListener('click', () => {
      this.close()
    })

    this.htmlTag = document.getElementsByTagName("html")[0];
  }

  open() {
    this.miniCart.classList.add('animate', 'active')
    this.cartBackdrop.classList.add('active')

    this.miniCart.addEventListener(
      'transitionend',
      () => {
        this.cartIcon.focus()
      },
      { once: true }
    )
    trapFocus(this.miniCart)

    scrollPositionCart = window.pageYOffset;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPositionCart}px`;
    document.body.style.width = '100%';

    document.querySelector('#shopify-section-header').style.zIndex = '89'
  }

  close() {
    this.miniCart.classList.remove('active')
    this.cartBackdrop.classList.remove('active')

    removeTrapFocus()
    document.body.removeEventListener('click', this.onBodyClick)
    document.querySelector('#shopify-section-header').style.zIndex = 'var(--zhighest)'

    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    window.scrollTo(0, scrollPositionCart);
  }

  handleBodyClick(evt) {
    const target = evt.target
    if (
      target !== this.miniCart &&
      !target.closest('#cart-icon-bubble') &&
      !this.miniCart.contains(target) &&
      target !== document.getElementById('notification-submit')
    ) {
      this.close()
    }
  }
}

let scrollPositionCart = 0;
let checkIfEventOnCartIcon = false;

customElements.define('mini-cart-toggle', MiniCartToggle)
